import type { DOMOutputSpec } from "prosemirror-model";
import { EditorState, Transaction } from "prosemirror-state";

import { NodeExtension } from "../extension";

export default class HardBreak extends NodeExtension {
	get name() {
		return "hard_break";
	}

	get node() {
		return {
			group: "inline",
			inline: true,
			selectable: false,
			parseDOM: [{ tag: "br" }],
			toDOM(): DOMOutputSpec {
				return ["br"];
			},
		};
	}

	keys() {
		return {
			"Shift-Enter": (state: EditorState, dispatch: ((tr: Transaction) => void) | undefined): boolean => {
				const tr = state.tr.replaceSelectionWith(this.$type.create());
				if (dispatch) {
					dispatch(tr.scrollIntoView());
				}
				return true;
			},
		};
	}
}
